import { Action } from "redux";
import { AppThunk } from "..";

export const SHOW_BASKET = "SHOW_BASKET";
export const SHOW_LOGIN = "SHOW_LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_BASM_STATUS = "UPDATE_BASM_STATUS";
export const SHOW_TICKETS = "SHOW_TICKETS";
export const UPDATE_BASKET_COUNT = "BASM_UPDATE_BASKET_COUNT";
export const UPDATE_BASM_PROFILE = "BASM_UPDATE_PROFILE_DATA";
export const UDPATE_AUTH_STATE = "BASM_UPDATE_AUTH_STATE";
export const UPDATE_SPONSER_QUOTA = "BASM_UPDATE_SPONSER_QUOTA";
export const UPDATE_SHOW_SPONSOR_BANNER = "UPDATE_SHOW_SPONSOR_BANNER";
export const SHOW_VOUCHER_REDEMPTION = "SHOW_VOUCHER_REDEMPTION";
export const SHOW_VOUCHER_PURCHASE = "SHOW_VOUCHER_PURCHASE";

export type BasmStatus = "NOT_LOADED" | "LOAD" | "LOADING" | "LOADED";
export enum BasmAuthState
{
    LoggedOut = 0,
    LoggedIn = 1
}

interface ShowBasketAction extends Action
{
    type: typeof SHOW_BASKET;
}

interface ShowLoginAction extends Action
{
    type: typeof SHOW_LOGIN;
}

interface LogOutAction extends Action
{
    type: typeof LOGOUT;
}

interface ShowTicketsAction extends Action
{
    type: typeof SHOW_TICKETS;
    eventNo: string;
    showNo?: string;
}

interface BasmUpdateStatusAction extends Action
{
    type: typeof UPDATE_BASM_STATUS;
    status: BasmStatus;
}

interface UpdateBasketCount extends Action
{
    type: typeof UPDATE_BASKET_COUNT;
    count: number;
}

interface UpdateBasmProfile extends Action
{
    type: typeof UPDATE_BASM_PROFILE;
    profile: BasmProfileData;
}

interface UpdateAuthState extends Action
{
    type: typeof UDPATE_AUTH_STATE;
    authState: BasmAuthState;
}

interface UpdateSponserQuota extends Action
{
    type: typeof UPDATE_SPONSER_QUOTA;
    sponserQuota: SponserQuota;
}

interface UpdateShowSponsorBannerAction extends Action
{
    type: typeof UPDATE_SHOW_SPONSOR_BANNER;
    showSponsorBanner: boolean;
}

const updateBasmStatus = (newStatus: BasmStatus) =>
{
    const action: BasmUpdateStatusAction = {
        type: UPDATE_BASM_STATUS,
        status: newStatus
    };
    return action;
};

export const showLoginAction = () =>
{
    const action: ShowLoginAction = {
        type: SHOW_LOGIN
    };
    return action;
};

export const showBasketAction = () =>
{
    const action: ShowBasketAction = {
        type: SHOW_BASKET
    };
    return action;
};

export const showTicketsAction = (eventNo: number, showNo?: number) =>
{
    const action: ShowTicketsAction = {
        type: SHOW_TICKETS,
        eventNo: eventNo.toString(),
        showNo: showNo ? showNo.toString() : undefined
    };
    return action;
};

export const updateBasketCount = (count: number) =>
{
    const action: UpdateBasketCount = {
        type: UPDATE_BASKET_COUNT,
        count: count
    };
    return action;
};

export const updateProfileData = (profile: BasmProfileData) =>
{
    const action: UpdateBasmProfile = {
        type: UPDATE_BASM_PROFILE,
        profile: profile
    };
    return action;
};

export const updateAuthState = (state: number) =>
{
    const action: UpdateAuthState = {
        type: UDPATE_AUTH_STATE,
        authState: state
    };
    return action;
};

export const updateSponserQuotaAction = (sponserQuota: SponserQuota) =>
{
    const action: UpdateSponserQuota = {
        type: UPDATE_SPONSER_QUOTA,
        sponserQuota: sponserQuota
    };
    return action;
};
export const updateShowSponsorBannerAction = (show: boolean) =>
{
    const action: UpdateShowSponsorBannerAction = {
        type: UPDATE_SHOW_SPONSOR_BANNER,
        showSponsorBanner: show
    };
    return action;
};

const loadBasmAsync = async (dispatch) =>
{
    const timeoutHandler = () =>
    {
        if (window.basm)
        {
            dispatch(updateBasmStatus("LOADED"));

            if(window?.location?.pathname === "/landingpages/english/")
            {
                window.basm.changeLanguage("en");
            }

            return Promise.resolve();
        }
        else
        {
            setTimeout(timeoutHandler, 500);
        }
    };
    timeoutHandler();
};

export const thunkLoadBasm = (): AppThunk => async dispatch =>
{
    await loadBasmAsync(dispatch);
};

export const showLoginAsync = () => async dispatch =>
{
    await loadBasmAsync(dispatch);
    dispatch(showLoginAction());
};

export const showBasketAsync = () => async dispatch =>
{
    await loadBasmAsync(dispatch);
    dispatch(showBasketAction());
};

export const showTicketsAsync = (eventNo: number, showNo?: number): AppThunk => async (dispatch) =>
{
    await loadBasmAsync(dispatch);
    const timeoutHandler = () =>
    {
        dispatch(showTicketsAction(eventNo, showNo));
    };
    setTimeout(timeoutHandler, 500);
};

export const thunkToggleSponsorBanner = (display: boolean): AppThunk => async (dispatch) =>
{
    dispatch(updateShowSponsorBannerAction(display));
};

export const getProfileData = () =>
{
    const promise = new Promise<BasmProfileData>((resolve, reject) =>
    {
        basm.getProfile((data) =>
        {
            resolve(data);
        });
    });

    return promise;
};

export const getCampaignData = () =>
{
    const promise = new Promise<SponserQuota>((resolve, reject) =>
    {
        basm.getCustomCampaignData((data) =>
        {
            resolve(data);
        });
    });

    return promise;
};

export const updateBasketCountAsync = (count: number): AppThunk => async dispatch =>
{
    dispatch(updateBasketCount(count));
};

export const updateBasmProfileAsync = (profile: BasmProfileData): AppThunk => async dispatch =>
{
    dispatch(updateProfileData(profile));
};

export const basmAuthChange = (authState: BasmAuthState): AppThunk => async (dispatch) =>
{
    dispatch(updateAuthState(authState));
    if (authState === BasmAuthState.LoggedIn)
    {
        getProfileData().then((profile) =>
        {
            dispatch(updateBasmProfileAsync(profile));
        });
        getCampaignData().then((sponserQuota) =>
        {
            dispatch(updateSponserQuotaAction(sponserQuota));
        });
    }
};

//#region Show Voucher Redemption
interface ShowVoucherRedemptionAction extends Action
{
    type: typeof SHOW_VOUCHER_REDEMPTION;
}

export const showVoucherRedemptionAction = () =>
{
    const action: ShowVoucherRedemptionAction = {
        type: SHOW_VOUCHER_REDEMPTION
    };
    return action;
};

export const showVoucherRedemptionAsync = (): AppThunk => async (dispatch) =>
{
    await loadBasmAsync(dispatch);
    dispatch(showVoucherRedemptionAction());
};
//#endregion

//#region Show Voucher Purchase
interface ShowVoucherPurchaseAction extends Action
{
    type: typeof SHOW_VOUCHER_PURCHASE;
}

const showVoucherPurchaseAction = (): ShowVoucherPurchaseAction => ({
    type: SHOW_VOUCHER_PURCHASE
});

export const thunkShowVoucherPurchase = (): AppThunk => async (dispatch) =>
{
    await loadBasmAsync(dispatch);
    dispatch(showVoucherPurchaseAction());
};
//#endregion

//#region
export const SHOW_CUSTOM_CAMPAIGN = "SHOW_CUSTOM_CAMPAIGN";
interface ShowCustomCampaignAction extends Action
{
    type: typeof SHOW_CUSTOM_CAMPAIGN;
}

const showCustomCampaignAction = (): ShowCustomCampaignAction => ({
    type: SHOW_CUSTOM_CAMPAIGN
});

export const thunkShowCustomCampaign = (): AppThunk => async (dispatch) =>
{
    await loadBasmAsync(dispatch);
    dispatch(showCustomCampaignAction());
};
//#endregion

export type BasmActions =
    ShowBasketAction |
    ShowLoginAction |
    LogOutAction |
    BasmUpdateStatusAction |
    ShowTicketsAction |
    UpdateBasketCount |
    UpdateBasmProfile |
    UpdateAuthState |
    UpdateSponserQuota |
    UpdateShowSponsorBannerAction |
    ShowVoucherRedemptionAction |
    ShowVoucherPurchaseAction |
    ShowCustomCampaignAction;